import { render, staticRenderFns } from "./SearchItemPlaceHolder.vue?vue&type=template&id=dc3f9866&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports